<template lang="pug">
.d-inline-block
  v-dialog(v-model='showPlans', width='680px')
    v-card(data-cy='landing-pages-modal')
      title-bar(dark) {{ title }}
        template(slot='extras')
          v-btn.close-icon(icon, @click='hide')
            v-icon close
      v-card-text
        v-layout(v-if='!hasCRMPremierPlan', row, wrap)
          v-layout(v-if='!isBundled', row, wrap, justify-center)
            v-flex.xs2
              h4 Billed Annually
            v-flex.xs1
              v-switch.my-0.ml-1.toggle-length(
                :input-value='isMonthlyBilling',
                height='10px',
                @change='toggleBillingLength'
              )
            v-flex.xs2
              h4 Billed Monthly
          v-flex.xs4.offset-xs4.border-plan.mb-2
            h3.center.title-plan {{ isMonthlyBilling ? "Monthly" : "Annual" }}
            span.center.caption(v-if='!isMonthlyBilling') Limited Time Offer
            h4.center(v-if='!isMonthlyBilling', style='text-decoration: line-through') $289
            h4.center {{ isMonthlyBilling ? "$29/mo" : "$197/yr" }}
            v-layout(row, wrap, justify-center)
              v-btn.btn-subscribe.current-plan(v-if='isCurrentPlan', small, :disabled='true') Current Plan
              v-btn.primary.btn-subscribe(
                v-else-if='landingPagesAddon && !isCurrentPlan && !isMonthlyBilling',
                small,
                flat,
                @click='subscribe(addonLandingPageSelected)'
              ) Upgrade
              v-btn.primary.btn-subscribe(
                v-else-if='landingPagesAddon && !isCurrentPlan && isMonthlyBilling',
                small,
                flat,
                href='mailto:support@liondesk.com'
              ) Contact Liondesk
              v-btn.primary.btn-subscribe(
                v-if='!landingPagesAddon',
                flat,
                small,
                @click='subscribe(addonLandingPageSelected)'
              ) Subscribe Now
              .btn-space
                a(
                  v-if='!hasCRMPremierPlan && landingPagesAddon && isCurrentPlan && !isCancelledPending && isCancellable',
                  @click='confirmCancel(addonLandingPageSelected)'
                ) Cancel Subscription
                p(v-else-if='isCancelledPending') Your current subscription ends <strong>{{ dateEnd | formatDate }}</strong>.
        h3.primary--text.text-xs-center Your Landing Page Subscription Includes
        ul.feature-list
          li.mt-1.item-feature(v-for='feature in subscriptionFeatures', row, wrap) {{ feature }}
        video.mt-2.video(width='475px', controls)
          source(
            src='https://ld-marketing.s3.us-west-2.amazonaws.com/video_ui_landingpages.mp4',
            type='video/mp4'
          )

  liondesk-dialog(
    dialog-title='Are you sure you want to cancel?',
    :value='cancelSubscription',
    :hide-cancel-button='false',
    :dialog-body-html='true',
    width='600px',
    ok-button-text='Cancel Subscription',
    cancel-button-text='Keep Plan',
    @click:ok='confirmCancelAddon',
    @click:cancel='cancelSubscription = false'
  )
    template(slot='body')
      div
        p.mt-2.mb-5 Your last day to access the Landing Pages will be <strong> {{ dateEnd | formatDate }} </strong>. Are you sure you want to cancel your {{ isMonthlyBilling ? "Monthly" : "Annual" }} Plan?
  liondesk-dialog(
    dialog-title='Confirm Action',
    :value='paymentUserSubscribed',
    :hide-cancel-button='false',
    :dialog-body-html='true',
    :loading='loadingRequest',
    width='600px',
    ok-button-text='Add Plan',
    cancel-button-text='Return',
    @click:ok='subscribePlan',
    @click:cancel='closeConfirmAction'
  )
    template(slot='body')
      div
        p.mt-2.mb-5 Are you sure you want to start your LionDesk Landing Pages
          | {{ isMonthlyBilling ? "Monthly" : "Annual" }} Plan for <strong>
          | ${{ price }} {{ isMonthlyBilling ? "charged monthly" : "charged annually" }} </strong>?
  liondesk-dialog(
    dialog-title='Payment Status',
    :value='showPaymentResult',
    :hide-cancel-button='true',
    :dialog-body-html='true',
    width='600px',
    ok-button-text='Ok',
    @click:ok='setShowPaymentResult(false)'
  )
    template(slot='body')
      div(v-if='errorPaymentResult != null')
        p {{ errorPaymentResult }}
      div(v-else)
        p {{ messageSuccessSubcribe }}
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import TitleBar from '@/Core/components/TitleBar';
import LiondeskDialog from '@/Core/components/LiondeskDialog';
import { formatDate } from '@/Core/filters/dates';
import {
  hasExpiredCC,
  ADDON_LANDING_PAGES_MONTHLY,
  ADDON_LANDING_PAGES_ANNUAL,
  ADDON_LANDING_PAGES_MONTHLY_PER_UNIT,
  ADDON_LANDING_PAGES_ANNUAL_PER_UNIT,
  ADDON_PLANS,
  STATUS_CANCELLED_PENDING,
  isPremierMonthlyPlan,
  isPremierAnnualPlan,
} from '@/Core/config/addons';
import {
  BUNDLE_SKUS,
  PLAN_LD_V2_PROPLUS_BUNDLE,
  PLAN_LD_V2_ELITE_BUNDLE,
} from '@/Core/config/subscription';

export default {
  name: 'PlansLandingPages',
  components: {
    TitleBar,
    LiondeskDialog,
  },
  props: {
    dialog: false,
    hideLandingPagesDialog: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      addonLandingPageMonthly: ADDON_LANDING_PAGES_MONTHLY,
      addonLandingPageAnnual: ADDON_LANDING_PAGES_ANNUAL,
      addonLandingPageMonthlyPerUnit: ADDON_LANDING_PAGES_MONTHLY_PER_UNIT,
      addonLandingPageAnnualPerUnit: ADDON_LANDING_PAGES_ANNUAL_PER_UNIT,
      cancelSubscription: false,
      subscriptionSelected: null,
      paymentUserSubscribed: false,
      loadingRequest: false,
      messageSuccessSubcribe: 'Landing Pages plan has been added successfully',
      subscriptionFeatures: [
        'Drag and drop page design',
        'High converting templates',
        'Mobile responsive pages',
        'Leads automatically connected to LionDesk',
        'Works great with LionDesk Facebook Ads',
        'Unlimited published Pages',
        'Lightning fast page loads',
        'SEO optimization',
      ],
      plans: ADDON_PLANS,
    };
  },
  computed: {
    ...mapState('payment', [
      'error',
      'showPaymentResult',
      'errorPaymentResult',
      'createAddonResponse',
      'cancelAddonResponse',
      'updateAddonResponse',
      'showPlans',
      'isMonthlyBilling',
      'addonId',
    ]),
    ...mapState('userInformation', ['user', 'subscription']),
    ...mapGetters('payment', [
      'planName',
      'userAddons',
      'landingPagesAddon',
      'hasLandingPagesMonthly',
    ]),
    ...mapGetters('userInformation', [
      'hasTrial',
      'isOnBrokerPurchasedPlan',
      'hasUserMLS',
      'userHasFeatureFlag',
    ]),
    title() {
      return this.landingPagesAddon ? 'Manage Subscriptions' : 'Select Landing Page Subscription';
    },
    isUserWithoutCC() {
      if (this.landingPagesAddon) return false;
      if (hasExpiredCC(this.user)) {
        return true;
      }
      return this.hasTrial || this.isOnBrokerPurchasedPlan || this.hasUserMLS;
    },
    dateEnd() {
      if (!this.subscription) return;

      const dateStarted = parseInt(this.subscription.next_billing_at);
      const date = new Date(dateStarted * 1000);
      return date;
    },
    addonLandingPageSelected() {
      if (this.isMonthlyBilling) {
        const landingPageMonthly = (this.landingPagesAddon === this.addonLandingPageMonthlyPerUnit) ? this.addonLandingPageMonthlyPerUnit : this.addonLandingPageMonthly;
        return landingPageMonthly;
      }
      const landingPageAnnual = (this.landingPagesAddon === this.addonLandingPageAnnualPerUnit) ? this.addonLandingPageAnnualPerUnit : this.addonLandingPageAnnual;
      return landingPageAnnual;
    },
    isCurrentPlan() {
      if (!this.landingPagesAddon) return false;
      if (!!this.hasLandingPagesMonthly === !!this.isMonthlyBilling) return true;
      return false;
    },
    price() {
      if(!this.addonId) return 0;
      return this.plans.find(p => p.id === this.addonId).price;
    },
    isCancelledPending() {
      return (
        this.landingPagesAddon && this.landingPagesAddon.txt_status === STATUS_CANCELLED_PENDING
      );
    },
    isBundled() {
      return this.user && BUNDLE_SKUS.includes(this.user.subscriptionOverview.details.id_item);
    },
    isCancellable() {
      return this.user && ![PLAN_LD_V2_PROPLUS_BUNDLE, PLAN_LD_V2_ELITE_BUNDLE].includes(
        this.user.subscriptionOverview.details.id_item,
      );
    },
    hasCRMPremierPlan() {
      return isPremierMonthlyPlan(this.user) || isPremierAnnualPlan(this.user);
    },
  },
  watch: {
    dialog: {
      handler(value) {
        this.setShowPlans(value);
      },
    },
    error: {
      handler(value) {
        if (value) {
          this.paymentUserSubscribed = false;
        }
      },
    },
    createAddonResponse: {
      handler(value) {
        if (value) {
          this.paymentUserSubscribed = false;
        }
      },
    },
    userAddons: {
      immediate: true,
      deep: true,
      handler(value) {
        if (!value || !this.landingPagesAddon) return;
        this.getSubscription(this.landingPagesAddon.id_chargebee);
      },
    },
  },
  async mounted() {
    this.getUserAddons();
    if (
      (this.landingPagesAddon &&
        (this.landingPagesAddon.id_item === this.addonLandingPageMonthly ||
          this.landingPagesAddon.id_item === this.addonLandingPageMonthlyPerUnit)) ||
      this.isBundled
    ) {
      // true == monthly
      this.toggleBillingLength(true);
    }
  },
  filters: {
    formatDate,
  },
  methods: {
    ...mapActions('payment', [
      'cancelAddon',
      'updateAddon',
      'addAddon',
      'resetErrorMessage',
      'getUserAddons',
      'toggleBillingLength',
      'setShowPlans',
      'setAddon',
      'setShowPaymentResult',
      'setShowDetailPlanSelected',
    ]),
    ...mapActions('userInformation', ['getSubscription']),
    ...mapActions('contactsTable', ['clearContactTableMessage']),
    async subscribePlan() {
      if (this.loadingRequest) return;
      this.loadingRequest = true;
      if (!this.subscriptionSelected) return;
      if (this.landingPagesAddon) {
        const landingPageMonthly =
          (this.landingPagesAddon.id_item === this.addonLandingPageMonthly)
            ? this.addonLandingPageMonthly
            : this.addonLandingPageMonthlyPerUnit;
        await this.updateAddon({
          addonIdSelected: this.addonLandingPageAnnualPerUnit,
          previousAddonId: landingPageMonthly,
        });
      } else {
        const selected = this.subscriptionSelected.includes('monthly') ? this.addonLandingPageMonthlyPerUnit : this.addonLandingPageAnnualPerUnit;
        await this.addAddon(selected);
      }
      this.loadingRequest = false;
      this.closeConfirmAction();
    },
    subscribe(addonId) {
      this.subscriptionSelected = addonId;
      this.setShowPlans(false);
      this.setAddon(this.subscriptionSelected);

      if (this.isUserWithoutCC) {
        this.setShowDetailPlanSelected(true);
        return;
      }
      this.paymentUserSubscribed = true;
    },
    hide() {
      this.loadingRequest = false;
      this.resetErrorMessage();
      this.clearContactTableMessage();
      this.setShowPlans(false);
      this.hideLandingPagesDialog();
    },
    confirmCancel(addonId) {
      
      let landingPagesType;
      if (this.isMonthlyBilling) {
        landingPagesType = addonId.includes('per-unit') ? this.addonLandingPageMonthlyPerUnit : this.addonLandingPageMonthly;
      } else {
        landingPagesType = addonId.includes('per-unit') ? this.addonLandingPageAnnualPerUnit : this.addonLandingPageAnnual;
      }
      this.subscriptionSelected = landingPagesType;
      this.cancelSubscription = true;
    },
    confirmCancelAddon() {
      this.cancelAddon(this.subscriptionSelected);
      this.cancelSubscription = false;
    },
    closeConfirmAction() {
      this.paymentUserSubscribed = false;
      this.setShowPlans(true);
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/Core/assets/scss/main.scss';
.popular-tab {
  background-color: var(--v-primary-base);
  color: white;
  border-radius: 5px 5px 0px 0px;
  text-align: center;
  margin-bottom: -27px;
  letter-spacing: -0.05em;
  font-weight: 700;
  font-size: 15px;
  padding: 4px 0 4px 0;
}

.time-offer {
  background-color: $lion-dark-blue;
  color: white;
  border-radius: 2px 2px 2px 2px;
  text-align: center;
  font-weight: 900;
  padding: 4px 0 4px 0;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  border-radius: 4px;
}

.item-feature {
  height: 24px;
}

.clear-border-top {
  border-top: 0px !important;
}

.clear-border-bottom {
  border-bottom: 0px !important;
}

.top {
  height: 25px;
}

.center {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.border-plan {
  border: 1px solid var(--v-primary-base);
}

.btn-subscribe {
  text-transform: none;
  font-size: 14px;
  font-weight: inherit;
}

.check-icon {
  color: var(--v-primary-base);
}

.close-icon {
  color: white;
}

.title-plan {
  margin-top: 10px;
  font-size: 18px;
}

.current-plan {
  font-weight: bolder;
}

.btn-space {
  text-align: center;
  width: 100%;
  display: block;
}

.list-features {
  font-size: 12px;
}

.text-help-trial {
  text-align: justify;
  margin-top: -10px;
  font-size: 13px;
}

button {
  .v-btn__content {
    padding-left: 4px;
    padding-right: 4px;
  }
}

.toggle-length {
  /deep/ .theme--light.v-input--switch__thumb {
    color: var(--v-primary-base) !important;
  }
  /deep/ .theme--light.v-input--switch__track {
    color: var(--v-primary-base) !important;
  }
}

.video {
  margin: 0 auto;
  display: block;
}

.feature-list {
  display: table;
  margin: 0 auto;
}
</style>
